import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from '@angular/common';
import {
  Auth,
  CheckSendOpnForConfirmationModel,
  RequestsService, SearchModel, SearchResultModel, SupplierOfferListService,
  SupplierOfferService, SupplierRoundListModel, SupplierRoundListService,
  TranslationManager,
  ViewState,
} from 'src/common';
import { RequestTabs } from 'src/common/enums/tabs';
import { TabItem } from 'src/views/components';


@Component({
  selector: 'request',
  templateUrl: 'request.component.html'
})

export class RequestComponent implements OnInit {

  @Input() state: ViewState;
  viewState = ViewState;
  requestId: number;
  supplierOfferId: number;
  requestRoundSupplierId: number;
  requestRoundId: number;
  translationManager = TranslationManager;
  checkDate: boolean;

  tabs: TabItem[] = [];
  requestTabs = RequestTabs;
  checkSendOpnForConfirmationModel: boolean;

  procurementModelUniqueIdentifier: string;
  isAuctionStarted: boolean;

  constructor(private route: ActivatedRoute, private router: Router, // private requestsService: RequestsService,
    private supplierOfferListViewService: SupplierOfferService,
    private supplierRoundService: SupplierRoundListService, private location: Location) {
    // this.requestId = this.route.snapshot.params.id;
  }

  ngOnInit(): void {

    this.supplierOfferId = this.route.snapshot.params['supplierOfferId'];
    this.requestRoundSupplierId = this.route.snapshot.params['requestRoundSupplierId'];
    this.requestRoundId = this.route.snapshot.params['requestRoundId'];

    if (this.requestRoundSupplierId) {
      let search1 = new SearchModel();
      search1.filters.push({
        'entity': "RequestRoundSupplierId",
        'value': this.requestRoundSupplierId + '',
        'action': "equals"
      });
      this.supplierRoundService.search(search1).then((result: SearchResultModel<SupplierRoundListModel>) => {
        let items1 = result.items;
        this.procurementModelUniqueIdentifier = items1[0].procurementModelUniqueIdentifier;
        this.isAuctionStarted = items1[0].isAuctionStarted;
      });
    }

    if (this.supplierOfferId) {

      let search = new SearchModel();
      search.filters = [];
      search.filters.push({ 'entity': "Id", 'value': this.supplierOfferId + '', 'action': "equals" });
      this.supplierOfferListViewService.search(search).then((result: SearchResultModel<any>) => {
        if (result) {
          let res = result.items[0];
          this.setCheckDate(res);
          this.requestId = res['requestId'];
          if (!this.checkDate && this.state == ViewState.Edit) {
            this.location.back();
          } else {
            this.initTabs();
          }
        }
      })
    } else if (this.requestRoundId) {

      let search = new SearchModel();
      search.filters = [];
      search.filters.push({ 'entity': "RequestRoundId", 'value': this.requestRoundId + '', 'action': "equals" });
      this.supplierRoundService.search(search).then((result: SearchResultModel<any>) => {
        if (result) {
          let res = result.items[0];
          this.requestId = res['requestId'];
          this.initTabs();
        }


      })
    }

  }

  ngAfterViewInit(): void {
    if (this.state != ViewState.Create) {
      this.initTabsDisabled();
    }
  }

  initTabs() {
    this.tabs[RequestTabs.Introduction] = {
      identifier: RequestTabs.Introduction,
      disabled: false,
      visible: true,
      active: true
    };
    this.tabs[RequestTabs.OpnOfferEvaluationMethods] = {
      identifier: RequestTabs.OpnOfferEvaluationMethods, disabled: false,
      visible: true, active: false
    };
    this.tabs[RequestTabs.RequirementList] = {
      identifier: RequestTabs.RequirementList,
      disabled: false,
      visible: true,
      active: false
    };
    this.tabs[RequestTabs.OpnCommercialLegalTerm] = {
      identifier: RequestTabs.OpnCommercialLegalTerm,
      disabled: false,
      visible: true,
      active: false
    };

    this.tabs[RequestTabs.OpnProjectdeadlinesList] = {
      identifier: RequestTabs.OpnProjectdeadlinesList,
      disabled: false,
      visible: true,
      active: false
    };
    this.tabs[RequestTabs.Documents] = {
      identifier: RequestTabs.Documents,
      disabled: this.state == ViewState.Create,
      visible: true,
      active: false
    };
    this.tabs[RequestTabs.Communication] = {
      identifier: RequestTabs.Communication,
      disabled: this.state == ViewState.Create,
      visible: true,
      active: false
    };
  }

  initTabsDisabled() {

  }

  checkTabs() {
    this.initTabsDisabled();
  }

  setTabActive(tab: RequestTabs) {
    this.tabs.forEach(item => {
      item.active = false;
    })
    this.tabs[tab].active = true;
  }

  navigateToBack() {
    this.location.back();
  }

  onNewSupplierOfferEvent(value) {
    this.supplierOfferId = value;
    this.state = this.viewState.Edit;
  }

  setCheckDate(res: any): void {
    let currentDate = new Date().getTime();
    let requestDeadline = new Date(res.completionDeadline).getTime();
    this.checkDate = currentDate > requestDeadline ? false : true;
  }
}
